import React, { Component } from 'react';

import AuthNavbar from '../navigation/authnavigation.jsx'
import LeftLink from '../leftlink/leftlink.jsx'
import PersonalInfo from './personalinfo.jsx'
import ChangePassword from './changepassword.jsx'
import MangeAlert from './managealert.jsx'
import ManagePin from './managepin.jsx'
import Messages from './messages.jsx'
import '../../stylesheet/tabdesign.css'
import { connect } from 'react-redux'
import * as actions from '../../actions/actions.jsx'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const mapStateToProps = state =>
    ({
        optionState: state.selectedTabReducer.selectedTabReducer,

    })
const mapDispatchToProps = dispatch =>
    ({
        fetchSelectedTab(selectedOption) {
            dispatch(
                actions.selectedtabAction(selectedOption)
            )
        },

    })

class MyProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: localStorage.getItem('taboption')|| "tab1"
        }
    }
    handleChange(e) {
        this.setState({
            selectedOption: e.target.value
        })
    }
    componentWillMount(){
        this.props.fetchSelectedTab(this.state.selectedOption)
    }
    componentDidMount(){
        localStorage.setItem("comp", "profilecomp")
        this.setState({
            selectedOption:localStorage.getItem('taboption')
        })
    }
    callBack(){
        this.setState({
            selectedOption:localStorage.getItem('taboption')
        })
    }
    
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>

                </div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="container" style={{ marginTop: "80px" }}>
                    <div className="row">
                        <div className="col-sm-3 box-shadow-style nopadding">
                            <LeftLink callBackFromParent={this.callBack.bind(this)} />
                        </div>
                        <div className="col-sm-9" style={{ padding: "0px 30px" }}>
                            <div className="row box-shadow-style" style={{ padding: "0px 0px", minHeight: "476px" }}>
                                <div className="pc-tab">
                                    <input id="tab1" type="radio" name="pct" value="tab1" checked={this.state.selectedOption === 'tab1'} onChange={this.handleChange.bind(this)} />
                                    <input id="tab2" type="radio" name="pct" value="tab2" checked={this.state.selectedOption === 'tab2'} onChange={this.handleChange.bind(this)} />
                                    <input id="tab3" type="radio" name="pct" value="tab3" checked={this.state.selectedOption === 'tab3'} onChange={this.handleChange.bind(this)} />
                                    <input id="tab4" type="radio" name="pct" value="tab4" checked={this.state.selectedOption === 'tab4'} onChange={this.handleChange.bind(this)} />
                                    {/* <input id="tab5" type="radio" name="pct" value="tab5" checked={this.state.selectedOption === 'tab5'} onChange={this.handleChange.bind(this)} /> */}
                                    <nav>
                                        <ul>
                                            <li className="tab1">
                                                <label style={{cursor:"pointer"}} htmlFor="tab1">Manage Profile</label>
                                            </li>
                                            <li className="tab2">
                                                <label style={{cursor:"pointer"}} htmlFor="tab2">Password / Secret Q&A</label>
                                            </li>
                                            <li className="tab3">
                                                <label style={{cursor:"pointer"}} htmlFor="tab3">Manage Alerts</label>
                                            </li>
                                            <li className="tab4">
                                                <label style={{cursor:"pointer"}} htmlFor="tab4">Change PIN</label>
                                            </li>
                                            {/* <li className="tab5">
                                                <label htmlFor="tab5">Messages</label>
                                            </li> */}
                                        </ul>
                                    </nav>
                                    <section>
                                        <div className="tab1">
                                            <PersonalInfo />
                                        </div>
                                        <div className="tab2">
                                            <ChangePassword />
                                        </div>
                                        <div className="tab3">
                                            <MangeAlert />
                                        </div>
                                        <div className="tab4">
                                            <ManagePin />
                                        </div>
                                        <div className="tab5">
                                            <Messages />
                                        </div>
                                    </section>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);


// WEBPACK FOOTER //
// ./src/components/myprofile/myprofile.jsx